import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import {
    BarChart2,
    Settings,
    Activity,
    Zap,
    User,
    BellRing,
    LogOut
} from "lucide-react";

export default function Sidebar() {
    const [expanded, setExpanded] = useState(false);
    const location = useLocation();

    // ✅ REMOVED "FYP" from this list
    const menuItems = [
        { name: "Dashboard", icon: <BarChart2 size={22} />, path: "/dashboard" },
        { name: "Devices", icon: <Zap size={22} />, path: "/devices" },
        { name: "Reports", icon: <Activity size={22} />, path: "/reports" },
        { name: "Alert Rules", icon: <BellRing size={22} />, path: "/alerts" },
        { name: "Profile", icon: <User size={22} />, path: "/profile" },
        { name: "Settings", icon: <Settings size={22} />, path: "/settings" },
    ];

    return (
        <motion.aside
            onMouseEnter={() => setExpanded(true)}
            onMouseLeave={() => setExpanded(false)}
            animate={{ width: expanded ? 240 : 80 }}
            transition={{ type: "spring", stiffness: 250, damping: 25 }}
            className="h-screen bg-gray-900/90 backdrop-blur-md p-4 flex flex-col shadow-2xl text-white fixed left-0 top-0 z-50 border-r border-gray-800"
        >
            {/* Logo */}
            <div className="flex items-center gap-3 mb-8 pl-2">
                <Zap className="text-neonPink drop-shadow-[0_0_6px_rgba(255,0,255,0.8)]" size={32} />
                <motion.span
                    animate={{ opacity: expanded ? 1 : 0 }}
                    className="text-xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-neonPink to-neonBlue whitespace-nowrap"
                >
                    PiWatch
                </motion.span>
            </div>

            {/* Menu */}
            <nav className="flex flex-col gap-2 flex-1">
                {menuItems.map((item) => {
                    const active = location.pathname === item.path;

                    return (
                        <Link
                            key={item.name}
                            to={item.path}
                            className={`flex items-center gap-4 p-3 rounded-xl transition-all duration-200 ${
                                active
                                    ? "bg-gray-800 text-neonPink border-l-4 border-neonPink"
                                    : "text-gray-400 hover:bg-gray-800 hover:text-white"
                            }`}
                        >
                            {/* Icon */}
                            <span className={active ? "text-neonPink" : "group-hover:text-neonBlue"}>
                                {item.icon}
                            </span>

                            {/* Label */}
                            <motion.span
                                animate={{
                                    opacity: expanded ? 1 : 0,
                                    width: expanded ? "auto" : 0
                                }}
                                className="text-sm font-medium whitespace-nowrap overflow-hidden"
                            >
                                {item.name}
                            </motion.span>
                        </Link>
                    );
                })}
            </nav>

            {/* Exit */}
            <div className="mt-auto border-t border-gray-700 pt-4">
                <Link
                    to="/"
                    className="flex items-center gap-4 p-3 rounded-xl text-red-400 hover:bg-red-500/10 hover:text-red-300 transition-all"
                >
                    <LogOut size={22} />
                    <motion.div
                        animate={{ opacity: expanded ? 1 : 0 }}
                        className="overflow-hidden"
                    >
                        <span className="text-sm font-bold block">Exit App</span>
                        <span className="text-xs text-gray-500 block">
                            Back to Portfolio
                        </span>
                    </motion.div>
                </Link>
            </div>
        </motion.aside>
    );
}